import React, { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../img/icontecver.png";

function HistorialSolicitud({ idSolicitud }) {
  const [show, setShow] = useState(false);
  const [historial, setHistorial] = useState([]);
  const [loading, setLoading] = useState(false);

  const obtenerHistorial = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://contratosback-dev.azurewebsites.net/api/v1/LogSolicitud/${idSolicitud}`
      );
      const datosOrdenados = res.data.sort((a, b) => a.id - b.id);
      setHistorial(datosOrdenados);
    } catch (error) {
      console.error("Error al obtener historial:", error);
    } finally {
      setLoading(false);
    }
  };

  const abrirModal = () => {
    obtenerHistorial();
    setShow(true);
  };

  const cerrarModal = () => setShow(false);

  const formatearFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString("es-CO", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const generarPDFdesdeDatos = () => {
    const reader = new FileReader();

    reader.onload = function (e) {
      const doc = new jsPDF();
      const logoBase64 = e.target.result;

      // Logo
      doc.addImage(logoBase64, "PNG", 10, 1, 30, 25);

      // Título
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("Aplicación Contratos", 75, 20);

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Historial del contrato #${idSolicitud}`, 15, 35);

      // Crear tabla con los datos
      const rows = historial.map((item, index) => [
        index + 1,
        item.accion,
        item.descripcion,
        item.nombre,
        formatearFecha(item.fecha),
      ]);

      autoTable(doc, {
        startY: 40,
        head: [["#", "Acción", "Descripción", "Usuario", "Fecha"]],
        body: rows,
        theme: "striped",
        styles: {
          font: "helvetica",
          fontSize: 10,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          halign: "center",
        },
        bodyStyles: {
          valign: "top",
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 10 },
          1: { cellWidth: 30 },
          2: { cellWidth: 50 },
          3: { cellWidth: 40 },
          4: { cellWidth: 40 },
        },
      });

      doc.save(`Historial_Solicitud_${idSolicitud}.pdf`);
    };

    // Convertir imagen a base64
    fetch(logo)
      .then((res) => res.blob())
      .then((blob) => reader.readAsDataURL(blob));
  };

  return (
    <>
      <Button variant="info" size="sm" onClick={abrirModal}>
        Ver Historial
      </Button>

      <Modal show={show} onHide={cerrarModal} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Historial del contrato #{idSolicitud}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center p-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : historial.length === 0 ? (
            <div className="text-center text-muted">
              No hay historial disponible.
            </div>
          ) : (
            <div>
              <ul className="timeline">
                {historial.map((item) => (
                  <li key={item.id} className="timeline-item">
                    <span className="timeline-icon bg-primary" />
                    <div className="timeline-content">
                      <h6>
                        {item.accion} <strong>{item.descripcion}</strong>
                      </h6>
                      <p className="text-muted mb-1">
                        Por: <strong>{item.nombre}</strong>
                      </p>
                      <small className="text-primary">
                        Fecha: {formatearFecha(item.fecha)}
                      </small>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="text-end mt-3">
                <Button
                  variant="success"
                  size="sm"
                  onClick={generarPDFdesdeDatos}
                >
                  Descargar PDF
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cerrarModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .timeline {
          list-style: none;
          padding: 0;
          position: relative;
        }
        .timeline::before {
          content: '';
          position: absolute;
          left: 20px;
          top: 0;
          bottom: 0;
          width: 2px;
          background: #007bff;
        }
        .timeline-item {
          position: relative;
          margin-left: 40px;
          margin-bottom: 20px;
        }
        .timeline-icon {
          position: absolute;
          left: -10px;
          top: 4px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: #007bff;
        }
        .timeline-content {
          background: #f8f9fa;
          padding: 15px;
          border-radius: 8px;
          box-shadow: 0 0 5px rgba(0,0,0,0.1);
        }
      `}</style>
    </>
  );
}

export default HistorialSolicitud;
